import React from 'react'
import styled from 'styled-components'
import ContainerHeading from '../../../components/layout/ContainerHeading'
import { UpdatingIndicatorSpan, UpdatingIndicatorEllipsisContainer, ListRow, Column, ColumnStyle, ColumnResponsiveInnerContainer,
 ActionColumnStyleRightAligned, ActionIconContainer, H1, GridContainer, GridSection, DataViewIconContainer, ActionButton, ActionLink } from '../styled-elements'
import styledTheme from '../../../styles/theme'
import ArrowRightBoldCircle from '../../../components/icons/ArrowRightBoldCircle'
import ChartLine from '../../../components/icons/ChartLine'
import Moment from 'moment-timezone'
import GrowingSeasonGraph from '../../../components/dataViews/GrowingSeasonGraph'
import { canUpdateGrowingSeason, hasCalculatedGrowingSeasonData } from '../../../utils/growingSeasonUtils'

const UpdatingIndicator = ({isMobileView}) => <UpdatingIndicatorSpan isMobileView={isMobileView}>
    Updating
    <UpdatingIndicatorEllipsisContainer />
  </UpdatingIndicatorSpan>

const GrowingSeasonHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`

const GrowingSeasonHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const BackLinkRow = styled.div`
  margin-bottom: 12px;
`

export default class GrowingSeason extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      layoutWidth: this.getLayoutWdth(),
    }
    this.graphComponent = React.createRef()
  }

  getLayoutWdth = () => {
    if (typeof window === 'undefined') return styledTheme.breakpoints.lg
    return window.innerWidth
  }

  resizeHandler = (e) => {
    if (e.target.innerWidth===this.state.layoutWidth) return
    this.setState({ layoutWidth: this.getLayoutWdth() })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler)
  }

  componentDidUpdate() {
  }

  formatDateUpdated = (lastUpdated,timezone) => {
    const dateUpdatedMoment = Moment.tz(lastUpdated,timezone)
    const nowMoment = Moment.tz(new Date(),timezone)
    const diffDuration  = Moment.duration(nowMoment.diff(dateUpdatedMoment))
    const diffDays = diffDuration ? diffDuration.asDays() : 0
    const diffHours = diffDuration ? diffDuration.asHours() : 0
    const diffMins = diffDuration ? diffDuration.asMinutes() : 0

    let updatedAtRelativeStr = ''

    if (diffHours < 2) {
      if (diffMins < 1) {
        updatedAtRelativeStr = `less than a minute ago`
      } else if (diffMins < 2) {
        updatedAtRelativeStr = `a minute ago`
      } else {
        updatedAtRelativeStr = `${parseInt(diffMins)} minutes ago`
      }
    } else if (diffHours < 48) {
      updatedAtRelativeStr = `${parseInt(diffHours)} hour${diffHours > 1 ? 's' : ''} ago`
    } else {
      updatedAtRelativeStr = `${parseInt(diffDays)} day${diffDays > 1 ? 's' : ''} ago`
    }

    let updatedAtTimeStr = dateUpdatedMoment.format("HH:mm")
    if ((nowMoment.format("DD MMM YYYY")!==dateUpdatedMoment.format("DD MMM YYYY")) && (diffHours >= 24)) {
      updatedAtTimeStr += ` on ${dateUpdatedMoment.format("DD MMM")}`
      if (nowMoment.format("YYYY")!==dateUpdatedMoment.format("YYYY")) {
        updatedAtTimeStr += ` on ${dateUpdatedMoment.format("YYYY")}`
      }
    }

    if (diffHours < 240) {
      updatedAtTimeStr += ` (${updatedAtRelativeStr})`
    }

    return `${updatedAtTimeStr}`
  }

  isMobileView = () => {
    const screenWidth = window.innerWidth
    return (screenWidth < styledTheme.breakpoints.md)
  }

  renderDataViewsRows(dataViews) {
    const growingSeasonSlug = this.props.growingSeason.slug
    return dataViews.sort((a,b) => a.sort_order-b.sort_order).map((dv,index) => <ListRow divisions={12} key={index} onClick={this.props.rowClickHandler.bind(this,growingSeasonSlug,dv.slug)}>
      <Column xs={10} style={ColumnStyle}><ColumnResponsiveInnerContainer><DataViewIconContainer><ChartLine /></DataViewIconContainer>{dv.name}</ColumnResponsiveInnerContainer></Column>
      <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer onClick={this.props.rowClickHandler.bind(this,growingSeasonSlug,dv.slug)}><ArrowRightBoldCircle right /></ActionIconContainer></Column>
    </ListRow>)
  }

  renderShowDataView(props,state) {
    const { dispatch, growingSeason, dataView, closeDataViewHandler } = props
    if (!growingSeason) return null
    if (dataView) {
      switch (dataView.data_view_type_category) {
        case 'graph':
          const options = props.dataViewHash || {}
          return <GrowingSeasonGraph
            closeDataViewHandler={closeDataViewHandler}
            dispatch={dispatch}
            growingSeason={growingSeason}
            dataView={dataView}
            options={options}
            dataViewSummary={props.dataViews}
            ref={this.graphComponent}
          />
        default:
          return null
      }
    }
  }

  renderGrowingSeasonEmptyState(growingSeason) {
    if (!growingSeason || hasCalculatedGrowingSeasonData(growingSeason)) return null

    return <div>
      <GrowingSeasonHeader>
        <H1>{growingSeason.name}</H1>
        <GrowingSeasonHeaderActions>
          {growingSeason.data_processing && <UpdatingIndicator isMobileView={this.isMobileView()} />}
          { canUpdateGrowingSeason(growingSeason) && <ActionButton disabled={growingSeason.data_processing} onClick={this.props.updateClickHandler}>Update</ActionButton> }
        </GrowingSeasonHeaderActions>
      </GrowingSeasonHeader>
      <GridContainer>
        <ContainerHeading title={`View Data`} />
        <GridSection>
          <div style={{ padding: '10px' }}>
            Growing season data is not available yet. Run Update after the sowing date to calculate the graphs.
          </div>
        </GridSection>
      </GridContainer>
    </div>
  }


  renderGrowingSeasonDataViewsList(growingSeason,dataViews) {
    if (!growingSeason || !dataViews.length) return null
    if (dataViews) {
      return <div>
        <GrowingSeasonHeader>
          <H1>{growingSeason.name}</H1>
          <GrowingSeasonHeaderActions>
            {growingSeason.data_processing && <UpdatingIndicator isMobileView={this.isMobileView()} />}
            { canUpdateGrowingSeason(growingSeason) && <ActionButton disabled={growingSeason.data_processing} onClick={this.props.updateClickHandler}>Update</ActionButton> }
          </GrowingSeasonHeaderActions>
        </GrowingSeasonHeader>
        <GridContainer>
          <ContainerHeading title={`View Data`} />
          <GridSection>
            {this.renderDataViewsRows(dataViews)}
          </GridSection>
        </GridContainer>
      </div>
    }
  }

  renderBody = (props,state) => {
    return <div>
      <BackLinkRow>
        <ActionLink onClick={props.backClickHandler}>Back to my growing seasons</ActionLink>
      </BackLinkRow>
      {this.renderGrowingSeasonEmptyState(props.growingSeason)}
      {this.renderGrowingSeasonDataViewsList(props.growingSeason,props.dataViews)}
      { props.dataView && this.renderShowDataView(props,state) }
    </div>
  }

  render = () => this.renderBody(this.props,this.state)

}
